import { ColumnDef } from "@tanstack/react-table";
import { RmaPaymentProps } from "../../store/actionType";

export const RmaPaymentTableColumns: ColumnDef<RmaPaymentProps>[] = [
  {
    id: "slNo",
    header: "Sl. No",
    cell: ({ row }) => row.index + 1,
  },
  {
    accessorKey: "BfsBenfId",
    header: () => <span>Beneficiary ID</span>,
    cell: (info) => info.getValue(),
  },
  {
    accessorKey: "BfsBenfTxnTime",
    header: () => <span>Beneficiary Txn Time</span>,
    cell: (info) => info.getValue(),
  },
  {
    accessorKey: "BfsBfsTxnId",
    header: () => <span>Transaction ID</span>,
    cell: (info) => info.getValue(),
  },
  {
    accessorKey: "BfsBfsTxnTime",
    header: () => <span>Transaction Time</span>,
    cell: (info) => info.getValue(),
  },
  {
    accessorKey: "BfsDebitAuthCode",
    header: () => <span>Debit Auth Code</span>,
    cell: (info) => info.getValue(),
  },
  {
    accessorKey: "BfsDebitAuthNo",
    header: () => <span>Debit Auth No</span>,
    cell: (info) => info.getValue(),
  },
  {
    accessorKey: "BfsMsgType",
    header: () => <span>Message Type</span>,
    cell: (info) => info.getValue(),
  },
  {
    accessorKey: "BfsOrderNo",
    header: () => <span>Order No</span>,
    cell: (info) => info.getValue(),
  },
  {
    accessorKey: "BfsRemitterBankId",
    header: () => <span>Remitter Bank ID</span>,
    cell: (info) => info.getValue(),
  },
  {
    accessorKey: "BfsRemitterName",
    header: () => <span>Remitter Name</span>,
    cell: (info) => info.getValue(),
  },
  {
    accessorKey: "BfsTxnAmount",
    header: () => <span>Txn Amount</span>,
    cell: (info) => info.getValue(),
  },
  {
    accessorKey: "BfsTxnCurrency",
    header: () => <span>Currency</span>,
    cell: (info) => info.getValue(),
  },
  {
    accessorKey: "MembershipDurationId",
    header: () => <span>Membership Duration</span>,
    cell: (info) => info.getValue(),
  },
  {
    accessorKey: "UserId",
    header: () => <span>User ID</span>,
    cell: (info) => info.getValue(),
  },
];

